/**
 * BT Lab badge — opens/closes the testing report dialog.
 */
class BtLabBadge extends HTMLElement {
  connectedCallback() {
    this.querySelector('[data-bt-lab-open]')?.addEventListener('click', this.#open);
    this.querySelector('[data-bt-lab-backdrop]')?.addEventListener('click', this.#onBackdropClick);
    this.querySelectorAll('[data-bt-lab-close]').forEach((el) => {
      el.addEventListener('click', this.#close);
    });
    this.querySelector('[data-bt-lab-dialog]')?.addEventListener('cancel', this.#onCancel);
  }

  disconnectedCallback() {
    this.querySelector('[data-bt-lab-open]')?.removeEventListener('click', this.#open);
    this.querySelector('[data-bt-lab-backdrop]')?.removeEventListener('click', this.#onBackdropClick);
    this.querySelectorAll('[data-bt-lab-close]').forEach((el) => {
      el.removeEventListener('click', this.#close);
    });
    this.querySelector('[data-bt-lab-dialog]')?.removeEventListener('cancel', this.#onCancel);
  }

  #dialog() {
    return this.querySelector('[data-bt-lab-dialog]');
  }

  #open = () => {
    const dialog = this.#dialog();
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('bt-lab-badge-open');
  };

  #close = () => {
    const dialog = this.#dialog();
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('bt-lab-badge-open');
  };

  #onBackdropClick = (event) => {
    if (event.target === event.currentTarget) this.#close();
  };

  #onCancel = (event) => {
    event.preventDefault();
    this.#close();
  };
}

if (!customElements.get('bt-lab-badge')) {
  customElements.define('bt-lab-badge', BtLabBadge);
}
